module.exports = __webpack_public_path__ + "img/boxes.9f2bc96e.png";